import { IconProps } from '../types';

const AttachmentIcon = (props: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7742 15.6364H7.15739C5.25766 15.6364 3.56699 14.2455 3.38519 12.3545C3.17613 10.1909 4.87589 8.36364 7.00287 8.36364H18.2376C19.4284 8.36364 20.5101 9.21818 20.6282 10.4C20.7646 11.7636 19.7011 12.9091 18.3649 12.9091H8.82079C8.32086 12.9091 7.91183 12.5 7.91183 12C7.91183 11.5 8.32086 11.0909 8.82079 11.0909H16.7742C17.1469 11.0909 17.4559 10.7818 17.4559 10.4091C17.4559 10.0364 17.1469 9.72727 16.7742 9.72727H8.94805C7.75731 9.72727 6.67564 10.5818 6.55748 11.7636C6.42113 13.1273 7.48462 14.2727 8.82079 14.2727H18.2104C20.1101 14.2727 21.8008 12.8818 21.9826 10.9909C22.1916 8.81818 20.4919 7 18.3649 7H7.21193C4.6032 7 2.26717 8.90909 2.02175 11.5091C1.74906 14.5 4.07601 17 7.00287 17H16.7742C17.1469 17 17.4559 16.6909 17.4559 16.3182C17.4559 15.9455 17.1469 15.6364 16.7742 15.6364Z"
      fill="#969696"
    />
    <mask id="mask0_4980_75770" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#F7F7F7" />
    </mask>
    <g></g>
  </svg>
);

export default AttachmentIcon;
